import React from 'react';
import PropTypes, { string } from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import {
    BarChart, Bar, Cell, ResponsiveContainer,
} from 'recharts';
import { setCurrencyFormat, numToStringFormatter } from '../../../utils/helpers';

const data = [
    { id: 0, name: 'Page A', uv: 4000 },
    { id: 1, name: 'Page B', uv: 3000 },
    { id: 2, name: 'Page C', uv: 2000 },
    { id: 3, name: 'Page D', uv: 2780 },
    { id: 4, name: 'Page E', uv: 1890 },
    { id: 5, name: 'Page F', uv: 2390 },
    { id: 6, name: 'Page G', uv: 3490 },
    { id: 7, name: 'Page H', uv: 2000 },
    { id: 8, name: 'Page I', uv: 2780 },
    { id: 9, name: 'Page J', uv: 1890 },
];

const CustomTile = ({ title, value, color }) => (
    <Col md={12} xl={3} lg={6} xs={12} className="mb-3">
        <Card className="p-0">
            <CardBody className="dashboard__card-widget">
                <div className="card__title">
                    <h5 className="bold-text">{title}</h5>
                </div>
                <div className="dashboard__total">
                    <p className="dashboard__total-stat" style={{ fontSize: 11, fontWeight: 'bold' }}
                        title={value ? setCurrencyFormat(Number(value.amount).toFixed(0), true) : 'N/A'} >
                        {value ? setCurrencyFormat(numToStringFormatter(value.amount, 2), true) : 'N/A'}
                        <p style={{ fontWeight: 'normal' }}
                            title={value ? setCurrencyFormat(Number(value.orderCount).toFixed(0), false) : 'N/A'} >
                            Orders: {value ? setCurrencyFormat(
                                numToStringFormatter(value.orderCount, 2), false) : 'N/A'}
                        </p>
                    </p>

                    {value && <div className="dashboard__chart-container" style={{ width: '100%' }}>
                        <ResponsiveContainer height={40} width={80}>
                            <BarChart data={data}>
                                <Bar dataKey="uv">
                                    {data.map((entry, index) => (
                                        <Cell
                                            cursor="pointer"
                                            fill={index === 4 ? color?.[0] || '#4ce1b6' : color?.[1] || '#70bbfd'}
                                            key={entry.id}
                                        />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>}
                </div>
            </CardBody>
        </Card>
    </Col>
);


CustomTile.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.objectOf({}).isRequired,
    color: PropTypes.arrayOf(PropTypes.string).isRequired
};
export default CustomTile;
